import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UiContext } from 'uiContext';
import ExpandButton from 'controls/buttons/expandButton/expandButton';
import { ScoreItem } from 'mobx/commonTypes';
import SpeedStatMobile from 'components/speedStat/speedStatMobile';

export type DropdownMenuHeaderDesktopProps = {
  traffic_score: ScoreItem;
  isOpen: boolean;
  onChangeIsOpen: (isOpen: boolean) => void;
};

export default function DropdownMenuHeaderMobile({
  traffic_score,
  isOpen,
  onChangeIsOpen,
}: DropdownMenuHeaderDesktopProps) {
  const {
    spacings: {
      uiElems: {
        header: { mobile },
      },
      sp,
    },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: mobile.height,
        width: 1,
      }}
    >
      <Box
        sx={{
          'display': 'flex',
          'justifyContent': 'space-between',
          'alignItems': 'center',
          'width': 1,
          '& > *': {
            flexShrink: 0,
          },
          '& > *:not(:last-child)': {
            marginRight: sp.s40,
          },
        }}
      >
        <Typography sx={{ whiteSpace: 'nowrap' }} variant="f14">
          О ситуации на дорогах:
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: sp.s25,
            alignItems: 'center',
          }}
        >
          <SpeedStatMobile
            isOpen={isOpen}
            score={traffic_score.score}
          ></SpeedStatMobile>

          <ExpandButton
            isOpen={isOpen}
            onChangeIsOpen={onChangeIsOpen}
            isMobile={true}
            sizeKey="16x16"
          ></ExpandButton>
        </Box>
      </Box>
    </Box>
  );
}
